import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M10 13c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.346 3 3 3zm0-5c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zM13 0H7v3h6V0zm-1 2H8V1h4v1z',
    'M15.491 1H13v1h2.491c.276 0 .509.233.509.509V4H4V2.509C4 2.233 4.233 2 4.509 2H7V1H4.509C3.679 1 3 1.679 3 2.509v15.982C3 19.321 3.679 20 4.509 20h10.982c.83 0 1.509-.679 1.509-1.509V2.509C17 1.679 16.321 1 15.491 1zM16 18.491c0 .276-.233.509-.509.509H4.509C4.233 19 4 18.767 4 18.491V17h12v1.491zM7.536 16c.506-.664 1.331-1 2.464-1s1.959.336 2.464 1H7.536zM16 16h-2.373c-.418-.864-1.393-2-3.627-2s-3.209 1.136-3.627 2H4V5h12v11z',
  ],
  height: 20,
  width: 20,
});
